import { WebSiteUsersService } from './../../services/webSiteUsers/webSiteUsers.service';
import { OrdersService } from './../../services/order/orders.service';
import { AuthService } from '../../services/Auth/auth.service';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PdvService } from '@app/services/pdv/pdv.service';

@Component({
    moduleId: module.id,
    selector: 'checkout',
    templateUrl: 'checkout.component.html',
    styleUrls: ['checkout.component.scss']
})
export class CheckoutComponent {
    isAuthenticated: boolean = false;
    activestep = 1;
    discount: number = 0;
    discountFrom: number = 0;
    amount;
    ourApp = false;
    constructor(
        private router: Router,
        private ordersSerive: OrdersService,
        private pdvService: PdvService,
        private webSiteUsersService: WebSiteUsersService
    ) {
        this.webSiteUsersService.listener.subscribe(
            log => {
                this.isAuthenticated = log
            }
        )
        this.ordersSerive.elementsNbr.subscribe(
            (elementsNbr) => {
                if (elementsNbr == 0) {
                    this.router.navigate(['/'])
                }
            }
        )
        this.ordersSerive.order.subscribe(
            (order) => {
                this.amount = order.amount;
            }
        )
        const subs7 = this.pdvService.pdv.subscribe(
            (data) => {
                this.discount=data.discount;
                this.discountFrom=data.discountFrom;
            }
        )
        this.ordersSerive.ourAppEvent.subscribe(
            data => {
                this.ourApp = data;
            }
        )
    }
    next() {
        if (this.activestep == 1) {
            this.activestep = (this.isAuthenticated) ? 3 : 2
        } else {
            this.activestep = 3;
        }
    }
    goTostep(i) {
        if (i < this.activestep) {
            this.activestep = i;
        }
    }
    back(i) {
        if (i == 2) {
            this.activestep = i;
            this.activestep = (this.isAuthenticated) ? 1 : 2
        } else {
            this.activestep = i;
        }
    }
}
